<template>
  <div class="el-card  pd20 posters">
    <!-- 返回 -->
    <el-divider></el-divider>
    <el-form :rules="rules" ref="form" :model="form" label-width="80px">
      <el-form-item label="姓名" prop="fullname" :label-width="formLabelWidth">
        <el-input v-model="form.fullname"  placeholder="请输入姓名"></el-input>
      </el-form-item>
      <!--  -->
      <!-- 头像 上传图片 -->
      <el-form-item label="头像" prop="head_img" :label-width="formLabelWidth">
        <el-upload class="upload-demo" :show-file-list="false" :http-request="uploadImg" :before-upload="beforeAvatarUpload">
          <el-button @click="imgType=1" size="small" type="primary">点击上传</el-button>
        </el-upload>
        <!--  -->
        <el-image class="up-image" :src="form.head_img">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" :style="{height:form.head_img?'':'150px','line-height':form.head_img?'':'150px'}" class="image-slot error">
            请上传图片...
          </div>
        </el-image>
      </el-form-item>
      <!-- 性别 -->
      <el-form-item label="性别" prop="sex" :label-width="formLabelWidth">
        <el-radio v-model="form.sex" :label="1">男</el-radio>
        <el-radio v-model="form.sex" :label="2">女</el-radio>
      </el-form-item>
      <!-- 微信号 -->
      <el-form-item label="微信号" prop="sex" :label-width="formLabelWidth">
        <el-input  v-model="form.sex"></el-input>
      </el-form-item>
      <!-- 手机号 -->
      <el-form-item label="手机号" prop="sex" :label-width="formLabelWidth">
        <el-input  v-model="form.sex"></el-input>
      </el-form-item>
      <!-- 行业 -->
      <el-form-item label="行业" prop="career" :label-width="formLabelWidth">
        <el-select v-model="form.career" placeholder="请选择行业" :disabled="is_edit">
          <el-option v-for="(item,index) in career" :key="index" :label="item.choice" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 岗位职能 -->
      <el-form-item label="岗位职能" prop="job_office" :label-width="formLabelWidth">
        <el-select v-model="form.job_office" placeholder="请选择职能" :disabled="is_edit">
          <el-option v-for="(item,index) in job_office" :key="index" :label="item.choice" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 职位 -->
      <el-form-item label="职位" prop="job_title" :label-width="formLabelWidth">
        <el-select v-model="form.job_title" placeholder="请选择职位" :disabled="is_edit">
          <el-option v-for="(item,index) in job_title" :key="index" :label="item.choice" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 工作年限 -->
      <el-form-item label="工作年限" prop="work_age" :label-width="formLabelWidth">
        <el-input  v-model="form.work_age" placeholder="请输入工作年限"></el-input>
      </el-form-item>
      <!-- 微信二维码 上传图片 -->
      <el-form-item label="微信二维码" prop="wechat_qrcode" :label-width="formLabelWidth">
        <el-upload class="upload-demo" :show-file-list="false" :http-request="uploadImg" :before-upload="beforeAvatarUpload">
          <el-button @click="imgType=2" size="small" type="primary">点击上传</el-button>
        </el-upload>
        <!--  -->
        <el-image class="up-image" :src="form.wechat_qrcode">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" :style="{height:form.wechat_qrcode?'':'150px','line-height':form.wechat_qrcode?'':'150px'}" class="image-slot error">
            请上传图片...
          </div>
        </el-image>
      </el-form-item>
      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getInfo, updateInfo, upload_image} from "@/api/ta";
export default {
  data() {
      return {
        formLabelWidth: '120px',
        form: {
          fullname:'',
          head_img:'',
          sex:null,
          wechat:'',
          mobile:'',
          career:null,
          job_office:null,
          job_title:null,
          work_age:null,
          wechat_qrcode:''
        },
        imgType:null,
        career:[],
        job_office:[],
        job_title:[],
        //这是一个验证规则
        rules: {
          career: [{
            required: true, //是否必填
            message: '请选择行业', //错误提示信息
            trigger: ['change', 'click'] //检验方式（blur为鼠标点击其他地方，）
          }],
          job_office: [{
            required: true, //是否必填
            message: '请选择职能', //错误提示信息
            trigger: ['change', 'click'] //检验方式（blur为鼠标点击其他地方，）
          }],
          job_title: [{
            required: true, //是否必填
            message: '请选择职级', //错误提示信息
            trigger: ['change', 'click'] //检验方式（blur为鼠标点击其他地方，）
          }],
          fullname: [{
            required: true,
            message: '请输入海报名称',
            trigger: 'blur'
          }],
          head_img: [{
            required: true,
            message: '请上传头像',
            trigger: 'blur'
          }],
          sex: [{
            required: true,
            message: '请选择性别',
            trigger: 'blur'
          }],
          wechat: [{
            required: true,
            message: '请输入微信号',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }],
          work_age: [{
            required: true,
            message: '请输入工作年限',
            trigger: 'blur'
          }],
          wechat_qrcode: [{
            required: true,
            message: '请上传微信二维码',
            trigger: 'blur'
          }]
          
        }
      }
    },
    methods: {
      beforeAvatarUpload(file) {
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif') {
          isJPG = false;
          this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      uploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        // 携带当前讲座的id
        form.append("key", this.$route.path);
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          if(this.imgType==1){
            this.form.head_img = data.image_url;
          }else{
            this.form.wechat_qrcode = data.image_url;
          }
          
        });
      },
      // 提交数据
      save() {
        updateInfo(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '提交成功！',
            type: 'success'
          });
        });
      },
      //
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$message.warning('请检查数据是否为空？');
            return false;
          }
        });
      },
      pullData() {
        this.$showLoading();
        getInfo().then((data)=>{
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.form = data.item;
          this.career = data.career;
          this.job_office = data.job_office;
          this.job_title = data.job_title;
  
          this.$hideLoading();
        }).catch((err)=>{
            this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.posters {
  .el-input,
  .el-textarea {
    width: 500px;
  }
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}
</style>
